import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { ModelYear } from '@sm360/widget-commons-vehicle';
import { ShiftDigitalService } from '@sm360/widget-commons-general';

import { MODEL_YEARS } from 'build-and-quote/constants/sections.js';
import ModelYearComponent from 'build-and-quote/components/ModelYears/ModelYear.jsx';

import { getSectionAdditionalClasses } from 'build-and-quote/services/SectionClassesUtils/SectionClassesUtils.js';

import 'build-and-quote/components/ModelYears/modelYears.scss';

const ModelYears = ({
    availableModelYears,
    currentSection,
    imageServer,
    paymentFrequencyLabels,
    selectedModel,
    selectModelYear,
    displayCreditRate,
    displayFactoryOrder,
    noMakeListStr,
    modelListStr,
}) => {
    const sectionOpened = currentSection === MODEL_YEARS.value;

    const sectionClasses = ['bloc-container', 'section-select-your-model', 'section-background'];
    const sectionAdditionalClasses = getSectionAdditionalClasses(
        sectionClasses,
        sectionOpened,
        currentSection,
        MODEL_YEARS.value
    ).join(' ');

    const genericTitle = ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text')
        ? ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text').getValue()
        : LocaleService.t('modelYearSection.title');

    const sectionTitle = LocaleService.t('SECTIONS.TITLE.GENERAL', {
        title: genericTitle,
        model: `${selectedModel.model}`,
    });

    const sectionSubtitle = LocaleService.t('modelYearSection.subtitle');

    const background = `url(${ContentZonesService.getContentZone(
        'widget.build.and.buy',
        'year.model.background.img'
    ).getValue()})`;

    React.useEffect(() => {
        ShiftDigitalService.updateDrImpression(null, null, selectedModel);
        ShiftDigitalService.updateDrPageView(null, null, selectedModel);
    }, []);

    return (
        <ReactCollapse isOpened={sectionOpened} springConfig={{ stiffness: 140, damping: 26 }}>
            <section className={sectionAdditionalClasses} style={{ backgroundImage: background }}>
                <div className="bloc-container">
                    <div className="bloc-container-wrapper bloc-container__title">
                        <h3 className="sr-subtitle-1 is-centered">{sectionTitle}</h3>
                        <h1 className="sr-title-1 is-centered">{sectionSubtitle}</h1>
                    </div>
                    <div className="selection-year-container">
                        {availableModelYears.map((year) => (
                            <ModelYearComponent
                                paymentFrequencyLabel={paymentFrequencyLabels.perPeriod}
                                year={year}
                                selectedModel={selectedModel}
                                imageServer={imageServer}
                                onYearClick={() => selectModelYear(year)}
                                key={year.year}
                                displayCreditRate={displayCreditRate}
                                displayFactoryOrder={displayFactoryOrder}
                                noMakeListStr={noMakeListStr}
                                modelListStr={modelListStr}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </ReactCollapse>
    );
};

ModelYears.defaultProps = {
    availableModelYears: [],
    selectedModel: [],
    displayCreditRate: false,
    displayFactoryOrder: false,
    noMakeListStr: '',
    modelListStr: '',
};

ModelYears.propTypes = {
    availableModelYears: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.YearModel)),
    currentSection: PropTypes.number.isRequired,
    imageServer: PropTypes.shape({
        imageServerDomain: PropTypes.string.isRequired,
        imageServerFullSize: PropTypes.string.isRequired,
    }).isRequired,
    paymentFrequencyLabels: PropTypes.shape({
        perPeriod: PropTypes.string.isRequired,
    }).isRequired,
    selectedModel: PropTypes.shape({
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
    }),
    selectModelYear: PropTypes.func.isRequired,
    displayCreditRate: PropTypes.bool,
    displayFactoryOrder: PropTypes.bool,
    noMakeListStr: PropTypes.string,
    modelListStr: PropTypes.string,
};

ModelYears.displayName = 'ModelYears';

export default ModelYears;
